import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleMapsModule } from '@angular/google-maps';
import { MapService } from '../../services/map.service';
import { RealTimeNavigationService } from '../../services/real-time-navigation.service';
import { RouteDataService } from '../../services/route-data.service';
import { Point } from 'src/app/pages/custom-route/interfaces/custom-route.interface';
import { SOLID_POLYLINE, BORDER_POLYLINE, REMAIN_DOTTED_POLYLINE, FINISHED_DOTTED_POLYLINE } from './config/constants';
import { StepsNavigationMapService } from '../../services/steps-navigation.service';

@Component({
    selector: 'map-polylines',
    standalone: true,
    imports: [ 
        CommonModule, 
        GoogleMapsModule
    ],
    templateUrl: './polylines.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class MapPolylinesComponent {
    private _routeDataService: RouteDataService = inject(RouteDataService);
    private _mapService: MapService = inject(MapService);
    private _realTimeNavigationService: RealTimeNavigationService = inject(RealTimeNavigationService);
    private _stepsNavigationMapService: StepsNavigationMapService = inject(StepsNavigationMapService)
    public currentRouteDay = computed<Point[]>(() => this._routeDataService.getCurrentRouteDay());
    public projectedPoint = computed<google.maps.LatLngLiteral>(() => this._mapService.projectedPoint());
    private canAddMarker = computed<boolean>(() => this._realTimeNavigationService.canSetMarkerFromMap() && this._realTimeNavigationService.isFakeGPSActive())

    public solidPolylineOptions: google.maps.PolylineOptions = SOLID_POLYLINE();
    public borderPolylineOptions: google.maps.PolylineOptions = BORDER_POLYLINE();
    public remainDottedPolyLineOptions: google.maps.PolylineOptions = REMAIN_DOTTED_POLYLINE();
    public finishedDottedPolyLineOptions: google.maps.PolylineOptions = FINISHED_DOTTED_POLYLINE();

    public onPolylineClick(event: any, index: any): void {
        if (!this._realTimeNavigationService.isFakeGPSActive() && this._routeDataService.showDevPanel()){
            this._mapService.resetMarkerProjection();
            this._routeDataService.resetCurrentStepAndTrame();
            this._routeDataService.setPolylineStatusOnTrameIndex(index);
            this._routeDataService.setCurrentTrameIndex(index);
            this._routeDataService.setCurrentStepIndex(0);
            this._stepsNavigationMapService.setCurrentStep();
            return;
        }

        if (this.canAddMarker() && event.latLng) {
            const lat: number = event.latLng.lat();
            const lng: number = event.latLng.lng();
            const markerPosition: google.maps.LatLngLiteral = { lat, lng };
            this._realTimeNavigationService.setLocationMarkerOnCurrentSegment(markerPosition);
        }
    }

    public getFinished(polylinesPath: google.maps.LatLngLiteral[]): google.maps.LatLngLiteral[] {
        const projInfo = this._mapService.computeProjection(this.projectedPoint(), polylinesPath);
        if (!projInfo)
            return [];

        const { projectedPoint, segmentIndex } = projInfo;
        const traveledPath: google.maps.LatLngLiteral[] = [];
        for (let i = 0; i <= segmentIndex; i++) {
            traveledPath.push(polylinesPath[i]);
        }
        traveledPath.push(projectedPoint);
        return traveledPath;
    }

    public getRemaining(polylinesPath: google.maps.LatLngLiteral[]): google.maps.LatLngLiteral[] {
        const projInfo = this._mapService.computeProjection(this.projectedPoint(), polylinesPath);
        if (!projInfo)
            return [];

        const { projectedPoint, segmentIndex } = projInfo;
        const remainingPath: google.maps.LatLngLiteral[] = [];
        remainingPath.push(projectedPoint);
        for (let i = segmentIndex + 1; i < polylinesPath.length; i++) {
            remainingPath.push(polylinesPath[i]);
        }
        return remainingPath;
    }

}